import { isObject } from './is-object';
import { isPrimitive, PrimitiveType } from './is-primitive';

export function getCauseObject(cause: unknown) {
    if (!isObject(cause)) {
        return;
    }

    const causeObject: { name?: PrimitiveType; code?: PrimitiveType; message?: PrimitiveType } = {};

    if (isPrimitive(cause.name)) {
        causeObject.name = cause.name;
    }

    if (isPrimitive(cause.code)) {
        causeObject.code = cause.code;
    }

    if (isPrimitive(cause.message)) {
        causeObject.message = cause.message;
    }

    return causeObject;
}
